<template>
    <section class="container-form-commission">
        <div class="title">
            <span>Formulário Dados da Comissão</span>

            <i class="far fa-times" @click="closeModalRepeater" />
        </div>

        <div class="body-form-commission">
            <div v-for="repeater in setData" :key="repeater.id">
                <ui-input
                    v-if="['text', 'email', 'tel'].includes(repeater.type) && repeater.name != 'CEP' && (isJSON(repeater.options) ? JSON.parse(repeater.options).desktop.mask != 'mask-money' : repeater.options.desktop.mask != 'mask-money')"
                    ref="repeater.id"
                    v-model="form[repeater.id]"
                    :mask="setMask(isJSON(repeater.options) ? JSON.parse(repeater.options).desktop.mask : repeater.options.desktop.mask, form[repeater.id], repeater.id)"
                    :error="repeater.hasError"
                    :observation="repeater.observation"
                    :type="repeater.type"
                    :label="repeater.name"
                    :placeholder="repeater.placeholder"
                    @input="setDataTable(form[repeater.id], repeater.name)"
                    @verify="(a,b)=> validateField(a , b, isJSON(repeater.options) ? JSON.parse(repeater.options).desktop.mask : repeater.options.desktop.mask, repeater.id, repeater.type)"
                />

                <div v-if="repeater.name == 'CEP'">
                    <ui-input-cep 
                        v-model="form[repeater.id]"
                        @input="handleInput"/>
                </div>

                <div v-if="repeater.type === 'money' || (isJSON(repeater.options) ? JSON.parse(repeater.options).desktop.mask  === 'mask-money' : repeater.options.desktop.mask === 'mask-money') && repeater.type != 'select'">
                    <ui-input-money
                        v-model="form[repeater.id]"
                        :label="repeater.name"
                        :required="typeof repeater.required === 'boolean' ? repeater.required : repeater.required == 0 ? false : true"
                        color-value="#676767"
                        masked
                        @input="setDataTable(form[repeater.id], repeater.name)"
                    />
                </div>

                <ui-textarea
                    v-if="repeater.type == 'textarea'"
                    v-model="form[repeater.id]"
                    :label="repeater.name"
                    :placeholder="repeater.placeholder"
                    @input="setDataTable(form[repeater.id], repeater.name)"
                />

                <ui-select-v2
                    v-if="repeater.type == 'select'"
                    v-model="form[repeater.id]"
                    return-value="label"
                    design="br-all mgb-15"
                    :label="repeater.name"
                    :search="false"
                    :placeholder="repeater.placeholder"
                    :data="isJSON(repeater.options) ? JSON.parse(repeater.options).options : repeater.options.options "
                    @input="setDataTable(form[repeater.id], repeater.name)"
                />

                <ui-datepicker
                    v-if="repeater.type == 'date'"
                    v-model="form[repeater.id]"
                    :label="repeater.name"
                    :context="'today'"
                    @input="setDataTable(form[repeater.id], repeater.name, repeater.type)"
                />

                <ui-radio
                    v-if="repeater.type == 'radio'"
                    v-model="form[repeater.id]"
                    :label="repeater.name"
                    :name="repeater.slug"
                    @input="setDataTable(form[repeater.id], repeater.name)"
                >
                    <option v-for="(value,index) in repeater.options.options" :key="index" :value="value">
                        {{ value }}
                    </option>
                </ui-radio>
            </div>
        </div>
        <div class="buttons">
            <ui-button design="link md" @click="cancel()">Cancelar</ui-button>
            <ui-button design="success md" @click="saveIfFormHasData()">Salvar</ui-button>
        </div>
    </section>
</template>

<script>
    import {
        uiTextarea,
        uiInput,
        uiSelectV2,
        uiDatepicker,
        uiInputMoney

    } from '@/components/ui/form'

    import {uiButton} from '@/components/ui/buttons'

    import helpers from '@/mixins/helpers'

    const qs = require('qs')

    const moment = require('moment')
	require('moment/locale/pt-br')

    export default {
        name: 'repeater-inputs',
        components: {
            uiTextarea,
            uiInput,
            uiSelectV2,
            uiDatepicker,
            uiButton,
            uiInputMoney
        },

       mixins:[helpers],

        props: {
            data: {
                type: [Object, Array],
                required: true
            },
        },

        data() {
            return {
                form: {},
                setData: null,
                dataTable: {}
            }
        },

       created() {
         this.setData = this.sortObject(this.data, 'id')
        },

        mounted() {
            this.$root.$on('modal-open-repeater-form', () => {
                this.clearForm()
            })
        },

        methods: {
            cancel() {
                this.$emit('cancel')

            },
            /**
			 * Salva os dados dos campos repeater
			 */
            save() {
                let params = {}
                for (const repeater of this.data) {
                    const value = this.form[repeater.id];
                    params[`field_value[${repeater.pivot.field_id}][0][${repeater.id}]`] = value !== undefined ? value : ''
                }
               if(this.dataTable) {
                this.$root.$emit('save-dynamic-data-table', qs.stringify({ ...params }), this.dataTable)
                }
                this.$emit('loading')
                this.cancel()
            },
            /**
             * Define se o component de input deve ser mostrado para o repeater
             */
            showInput(type) {
                return type == 'text' || type == 'email' || type == 'tel'
            },
            /**
			 * Organiza como aparecerão os dados no card
			 */
            setDataTable(value, name, type) {
                if(type && type === 'date') this.dataTable[name] = moment(value).format('DD/MM/YYYY')
                else this.dataTable[name] = value
            },
            /**
			 * Limpa o formulário
			 */
            clearForm() {
                this.form = {}
                this.dataTable = {}
            },
            /**
			 * Valida se há dados para salvar o formulário ou não
			 */
            saveIfFormHasData() {
                if (this.formHasData()) {
                    this.save()
                }
            },
            /**
			 * Verifica se há dados no formulário
			 */
            formHasData() {
                for (const repeater of this.data) {
                    if (this.form[repeater.id]) {
                        return true
                    }
                }
                return false
            },
            /**
            * Fecha o modal para preencimento dos campos repeater
            */
            closeModalRepeater() {
                this.$root.$emit('modal-close-repeater-form')
            },
            setMask(maskType, inputValue, id, name) {
                let item = null
                
                if (maskType === 'mask-cep') {
                    item = '#####-###'
                } else if (maskType === 'mask-phone' && name === 'Telefone') {
                    item = '(##) ####-####'
                } else if (maskType === 'mask-phone' || name === 'Celular') {
                    item = '(##) #####-####'
                } else if (maskType === 'mask-cpf' || maskType === 'mask-cnpj') {
                    // Determine if input is CPF or CNPJ and set mask accordingly
                    const isCPF = inputValue && inputValue.replace(/\D/g, '').length === 11
                    item = isCPF ? '###.###.###-##' : '##.###.###/####-##'
                
                }
                
                return item
            },
            setCep(cep, response) {
                this.setData.map(value => {
                    if(value.name === 'CEP') {
                        this.form[value.id] = cep
                    }
                    if(value.name === 'Endereço') {
                        this.form[value.id] = response.logradouro
                    }
                    if(value.name === 'Bairro') {
                        this.form[value.id] = response.bairro
                    }
                     if(value.name === 'Cidade') {
                        this.form[value.id] = response.localidade
                    }
                    if(value.name === 'Estado') {
                        this.form[value.id] = response.uf
                    }
                })
            },
            handleInput(event) { 
                this.setCep(event.cep, event.data)
            },
            validateField(event , inputValue, inputMask, id, type) {
                this.isValidEmail = inputValue === '' || event
                const indexField = this.setData.findIndex(field => field.id === id)
                let messageError = ''
                let hasError = false

                if(inputMask === 'mask-cpf' || inputMask === 'mask-cnpj') {
                    const isCPF = inputValue && inputValue.replace(/\D/g, '').length === 11
                    let isValidCPFOrCNPJ = isCPF ? this.$mx_validateCPF(inputValue) : this.$mx_validateCNPJ(inputValue)
        
                    this.isValidCPFOrCNPJ = isValidCPFOrCNPJ

                    if(!this.isValidCPFOrCNPJ && !inputValue || this.isValidCPFOrCNPJ && inputValue ) {
                        if(!inputValue) {
                            this.isValidCPFOrCNPJ = true
                        }
                        hasError = false
                        messageError = ''
                    }else if(!this.isValidCPFOrCNPJ && inputValue){
                        hasError = true
                        messageError = 'Digite um CPF ou CNPJ válido.'
                    }
                } else  if(!this.isValidEmail && type === 'email') {
                    hasError = true
                    messageError = 'Digite um email válido.'
                } else {
                    hasError = false
                    messageError = ''
                }

                if(indexField !== -1) {
                    this.$set(this.setData[indexField], 'hasError', hasError)
                    this.$set(this.setData[indexField], 'observation', messageError)  
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>